import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SPAN: `${cleanedFilename(__filename)}-span`,
};
